import React, { Component } from 'react';
import { object, bool, func } from 'prop-types';
import { map, get, isEmpty } from 'lodash';
import { Icon, Text, FlexContainer, Row, Column, DrawerError } from '../../common';

const RenderUpdateShippingResponse = ({ responseData }) => {
    const { generalError, shippingNotValid, notFound, ok } = get(responseData, 'updateShippingData.data', {});
    const withErrors = !isEmpty(generalError) || !isEmpty(shippingNotValid) || !isEmpty(notFound);
    const partialRescheduling = withErrors && !isEmpty(ok);
    const successfulRescheduling = !withErrors;
    const failedRescheduling = isEmpty(ok);

    return <>
        <Icon name='check-mark' size={37} color='#4bb357' />
        <Text text='¡Listo!' size={25} strong paddingTop={11} />
        { successfulRescheduling && <Text text='Se reprogramó todo exitosamente' size={15} semibold paddingBottom={11} />}
        { partialRescheduling && <Text text='Ocurrió un problema y no todas las órdenes se reprogramaron exitosamente' size={15} semibold paddingBottom={11} />}
        { failedRescheduling && <Text text='No se reprogramó ningún pedido' size={15} semibold paddingBottom={11} />}
    </>;
};

RenderUpdateShippingResponse.propTypes = {
    responseData: object
};

export default class ModificationRealized extends Component {
    static propTypes = {
        data: object,
        responseData: object,
        fromMassiveActions: bool,
        onCancel: func
    }

    render () {
        const { data, fromMassiveActions, responseData, onCancel } = this.props;
        const { status } = get(responseData, 'updateShippingData', {});

        if (!fromMassiveActions && status !== '200') return <DrawerError onCancel={onCancel} />;

        return (<>
            {!fromMassiveActions ? <>
                <Icon name='check-mark' size={37} color='#4bb357' />
                <Text text='¡Listo!' size={25} strong paddingTop={11} />
                <Text text='Los cambios han sido aplicados' size={15} semibold paddingBottom={11} />
                <Text text='Nueva información de entrega:' size={13} />
                <FlexContainer mY={15} direction='column'>
                    { map(data, ({ label, value }) => {
                        if (value) {
                            return (<Row pB={3}>
                                <Column>
                                    <Text size={11} text={label} />
                                </Column>
                                <Column>
                                    <Text size={11} text={value} align='right' />
                                </Column>
                            </Row>);
                        }
                    })}
                </FlexContainer>
            </> : <RenderUpdateShippingResponse responseData={responseData} />}
        </>);
    }
};
